import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { eguardAnimations } from '../../core/animations';
import { EguardConfigService } from '../../core/services/config.service';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';

@Component({
    selector: 'eguard-content',
    templateUrl: './eguard.component.html',
    styleUrls: ['./eguard.component.scss'],
    animations: eguardAnimations
})
export class EguardComponent implements OnInit, OnDestroy {
    onSettingsChanged: Subscription;
    eguardSettings: any;

    @HostBinding('@routerTransitionUp') routeAnimationUp = false;
    @HostBinding('@routerTransitionDown') routeAnimationDown = false;
    @HostBinding('@routerTransitionRight') routeAnimationRight = false;
    @HostBinding('@routerTransitionLeft') routeAnimationLeft = false;
    @HostBinding('@routerTransitionFade') routeAnimationFade = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private eguardConfig: EguardConfigService
    ) {
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .subscribe((event) => {
                switch (this.eguardSettings.routerAnimation) {
                    case 'fadeIn':
                        this.routeAnimationFade = !this.routeAnimationFade;
                        break;
                    case 'slideUp':
                        this.routeAnimationUp = !this.routeAnimationUp;
                        break;
                    case 'slideDown':
                        this.routeAnimationDown = !this.routeAnimationDown;
                        break;
                    case 'slideRight':
                        this.routeAnimationRight = !this.routeAnimationRight;
                        break;
                    case 'slideLeft':
                        this.routeAnimationLeft = !this.routeAnimationLeft;
                        break;
                }
            });

        this.onSettingsChanged =
            this.eguardConfig.onSettingsChanged
                .subscribe(
                (newSettings) => {
                    this.eguardSettings = newSettings;
                }
                );
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.onSettingsChanged.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/eguard.component.ts